import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { ProductTemplate } from 'types/productServiceV2';
import { AttributeInfo } from './uwProductsModule';

export default abstract class IUWProductsPage {
  public abstract requiredAttributes: AttributeInfo[];
  public abstract isLoading: boolean;

  protected abstract productTemplate: ProductTemplate | null;

  public abstract getInitialData(
    templateId: string,
    sponsorId: string,
    userRoles?: SupportedUserRoles[],
  ): Promise<void>;

  public abstract completeStep(): Promise<void>;

  protected abstract resetInitialData(): void;
}
